import React from "react";
import CatalogSearchPage from "../pages/CatalogSearchPage";
import styles from "../styles.module.css";

import DocumentProcessor from "../component/DocumentProcessor/DocumentProcessor";
import AnalyticsPage from "./AnalyticsPage";
import NewAnalysisPage from "../pages/NewAnalysisPage";

export default function MainContent({
    session,
    showMyOrders,
    showMyOffers,
    onToggleMyOrders,
    onToggleMyOffers,
    activeTab,

    orders,
    offers,

    reportData,
    reportLoading,

    setOffers,
    setOrders
}) {
    return (
        <>
            {activeTab === "catalog-search" && <CatalogSearchPage />}
            {activeTab === "new-analysis" && (
                <NewAnalysisPage
                    session={session}
                    showMyOrders={showMyOrders}
                    showMyOffers={showMyOffers}
                    onToggleMyOrders={onToggleMyOrders}
                    onToggleMyOffers={onToggleMyOffers}
                    orders={orders}
                    offers={offers}
                    setOrders={setOrders}
                    setOffers={setOffers}
                />
            )}

            {/* ================= ANALYTICS ================= */}
            {activeTab === "analytics" && (
                <AnalyticsPage
                    reportData={reportData}
                    reportLoading={reportLoading}
                />
            )}

            {/* ================= DOCUMENT PROCESSOR ================= */}
            {activeTab === "doc" && (
                <div className={styles.docFullWidth}>
                    <DocumentProcessor
                        setOrders={setOrders}
                        setOffers={setOffers}
                    />
                </div>
            )}
        </>
    );
}
